var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRmMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-star-1171148") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-31.000000, -301.000000)",
    fill: "#605F5E",
    fillRule: "nonzero",
    stroke: "#605F5E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Menu"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(17.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(15.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-star-1171148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39323651,0.0113900415 C9.32511286,0.0299162241 9.27084772,0.0815564315 9.24910954,0.148660581 L7.10150788,6.59915851 L0.226404149,6.59915851 C0.136251037,6.59945028 0.0564572614,6.65750913 0.0283033195,6.74328548 C0.000295020747,6.82891618 0.0303455726,6.92300539 0.102846473,6.97654232 L5.68807469,11.0594054 L3.54047303,17.7223929 C3.51246473,17.8087519 3.54324466,17.9032817 3.61676763,17.956378 C3.69029129,18.0096237 3.78977676,18.0093324 3.86285975,17.9556486 L9.44808797,13.8727856 L15.0333162,17.9556486 C15.1063992,18.0093312 15.2058884,18.0096225 15.2794083,17.956378 C15.352932,17.903278 15.3837112,17.8087519 15.3557029,17.7223929 L13.2081012,11.0594054 L18.7933295,6.97654232 C18.8658299,6.92300539 18.8958809,6.82891618 18.8678726,6.74328548 C18.8397183,6.65750913 18.7599249,6.59944979 18.6697718,6.59915851 L11.794668,6.59915851 L9.64706639,0.148660581 C9.61263934,0.0424605809 9.50089668,-0.0179290456 9.39324025,0.0113900415 L9.39323651,0.0113900415 Z M9.44808797,0.882858921 L11.4447062,6.87327386 C11.4751946,6.95671618 11.554988,7.01170954 11.6436809,7.0105444 L18.0314402,7.0105444 L12.8372079,10.8051087 C12.7644162,10.8585 12.7339282,10.9525892 12.7617909,11.0385112 L14.7584091,17.2350672 L9.5712722,13.4405029 L9.57141807,13.4405029 C9.49774877,13.3866747 9.39797201,13.3866747 9.32430271,13.4405029 L4.13716578,17.2350672 L6.13378404,11.0385112 L6.13392991,11.0385112 C6.16179219,10.9525892 6.13130415,10.8585 6.0585129,10.8051087 L0.864280531,7.0105444 L7.25203987,7.0105444 C7.34073281,7.01171141 7.42052659,6.95671618 7.45101456,6.87327386 L9.44808797,0.882858921 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmMenu);
export default __webpack_public_path__ + "static/media/Rm-menu.ff9cb4cafa0f77daf221624177f3a2d5.svg";
export { ForwardRef as ReactComponent };